import { Elena, html, nothing } from "@elenajs/core";

/** ░█ [ELENA]: Word marquee component */
export default class WordMarquee extends Elena(HTMLElement) {
  static tagName = "origin-word-marquee";
  static props = ["items", "speed", "gap", "accentColor", "accentSecondary", "direction"];

  items = "";
  speed = "25s";
  gap = "2rem";
  accentColor = "#00f2fe";
  accentSecondary = "#4facfe";
  direction = "normal";

  get parsedItems() {
    return (this.items || "")
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean);
  }

  get resolvedSpeed() {
    return this.getAttribute("speed") || this.speed;
  }

  get resolvedGap() {
    return this.getAttribute("gap") || this.gap;
  }

  get resolvedAccentColor() {
    return this.getAttribute("accent-color") || this.getAttribute("accentColor") || this.accentColor;
  }

  get resolvedAccentSecondary() {
    return this.getAttribute("accent-secondary") || this.getAttribute("accentSecondary") || this.accentSecondary;
  }

  get resolvedDirection() {
    return (this.getAttribute("direction") || this.direction || "normal").toLowerCase();
  }

  get isReverse() {
    return ["reverse", "rtl", "right"].includes(this.resolvedDirection);
  }

  get styleVariables() {
    return html`
      style="--marquee-speed:${this.resolvedSpeed};--gap:${this.resolvedGap};--accent-color:${this.resolvedAccentColor};--accent-secondary:${this.resolvedAccentSecondary};"
    `;
  }

  render() {
    if (!this.parsedItems.length) {
      return nothing;
    }

    return html`
      <div
        class="marquee-wrapper ${this.isReverse ? "marquee-reverse" : ""}"
        data-speed="${this.resolvedSpeed}"
        ${this.styleVariables}
      >
        <div class="marquee-content">
          ${this.parsedItems.map((item) => html`<span class="item">${item}</span>`)}
        </div>
        <div class="marquee-content marquee-clone" aria-hidden="true">
          ${this.parsedItems.map((item) => html`<span class="item">${item}</span>`)}
        </div>
      </div>
    `;
  }
}



WordMarquee.define();

// Example usage:
// <stone-word-marquee
//   items="Инновации,Будущее уже здесь,Креатив,Дизайн мирового уровня"
//   speed="25s"
//   gap="2rem"
//   accent-color="#00f2fe"
//   accent-secondary="#4facfe"
//   direction="normal"
// ></stone-word-marquee>

